import _ from 'lodash';

import Account, { AccountType } from 'models/account';
import FbPageAccountContent from 'models/fb_page_account_content';
import FbPageAccountSecretContent from 'models/fb_page_account_secret_content';
import FbPagesSelection from 'models/modal/fb_pages_selection';
import OpenModal from 'actions/modal/open_modal';
import qconsole from 'scripts/lib/qconsole';

export default class FbApiGatewayObserver {
  constructor(context) {
    this.context = context;
  }

  handleRequestFbPagesSuccess(pages) {
    const accounts = _.map(pages, page => toAccount(page));
    this.context.stores.accounts.set(accounts);
    this.context.executeAction(OpenModal, FbPagesSelection.create());
  }

  handleRequestFbPagesError(fbApiResponse) {
    if (fbApiResponse.error) {
      throw new Error(fbApiResponse.error.message);
    } else {
      throw new Error('Response object was not received from Facebook API call');
    }
  }

  handleLoginSuccess() {
    this.context.gateways.fbApi.requestFbPages();
  }

  handleLoginError() {
    qconsole.log('User cancelled login or did not fully authorize');
  }
}

function toAccount(page) {
  return Account.create({
    type: AccountType.FB_MESSENGER,
    content: FbPageAccountContent.create({
      id: page.id,
      name: page.name,
      isTemporaryToken: true,
    }),
    secretContent: FbPageAccountSecretContent.create({
      authToken: page.accessToken,
    }),
    description: `${page.name} (id: ${page.id})`,
  });
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/channels/fb_api_gateway_observer.js